<!--<div mat-dialog-title class="">
<div class="d-flex justify-content-between">
  <div class="h3 d-inline-flex align-items-center">
    {{'PAY_WITH' | translate}}
  </div>
  <button mat-icon-button (click)="cancel()" class="dialog-close-button">
    <mat-icon aria-label="Close Dialog">close</mat-icon>
  </button>
</div>
</div>-->

<!--<button mat-fab color="accent"  (click)="cancel()" class="_dialog-close">
<mat-icon>close</mat-icon>
</button>-->

<div mat-dialog-content style="position:relative; min-height:170px;">
  <div id="braintree-dropin-container"></div>
  @if (loading) {
    <div class="braintree-loader">
      <mat-spinner color="accent" strokeWidth="4" diameter="70"></mat-spinner>
    </div>
  }
</div>

<div mat-dialog-actions [ngClass]="{'justify-content-between': paymentOption == 'card', 'justify-content-end': paymentOption != 'card'}" class="d-flex">

  <button mat-button color="accent" class="lg mb-3" type="button" (mousedown)="cancel()">
    {{'Cancel' | translate}}
  </button>

  @if (paymentOption == 'card') {
    <button mat-raised-button color="accent" class="lg rounded mb-3" type="submit" (mousedown)="apply()" [disabled]="!instance" >
      <div class="d-flex justify-content-between align-items-center">
        <span>{{'PAY' | translate}}</span>
        <span class="px-2">{{data.total | lcurrency}}</span>
        <mat-icon class="_next">{{appService.nextIcon}}</mat-icon>
      </div>
    </button>
  }

</div>
